import React from "react";
import PartnerManagement from "../partner-management/PartnerManagement";
import { CUSTOMER_ENTITY } from "../partner-management/partnerEntityConfig";

/** Customer Management — same screen, table, form and flow as Partner Management. */
const CustomerManagement = () => <PartnerManagement entity={CUSTOMER_ENTITY} />;

export default CustomerManagement;
